



















import { Vue, Component, Prop } from 'vue-property-decorator'
import CSlider from './CSlider.vue'
@Component({
  components: {
    CSlider,
  },
})
export default class CAudio extends Vue {
  @Prop()
  cSrc!: string

  isPlaying: boolean = false

  currentTime: string = '00:00'

  totalTime: string = '00:00'

  playProgress: number = 0

  timeConvert(second: number) {
    if (second <= 0) {
      return '00:00'
    }
    let min: number | string = Math.floor(second / 60)
    if (min < 10) {
      min = `0${min}`
    }
    let s: number | string = Math.floor(second % 60)
    if (s < 10) {
      s = `0${s}`
    }
    return `${min}:${s}`
  }

  handleTimeUpdate(e: any) {
    this.currentTime = this.timeConvert(e.target.currentTime)
    this.playProgress = e.target.currentTime / e.target.duration
  }

  handleLoadedMetaData(e: any) {
    this.totalTime = this.timeConvert(e.target.duration)
  }

  handleChange(pos: number) {
    const audio: any = this.$refs.audio
    audio.currentTime = Math.floor(audio.duration * pos)
  }

  handleEnded() {
    this.isPlaying = false
    this.currentTime = '00:00'
    this.playProgress = 0
  }

  handlePaused() {
    this.isPlaying = false
  }

  play() {
    const audio: any = this.$refs.audio
    console.log(this.$refs.audio)
    if (audio.paused) {
      audio.play()
      this.isPlaying = true
      this.$emit('playstart')
    } else {
      audio.pause()
      this.isPlaying = false
    }
  }

}
